module.exports = __webpack_public_path__ + "img/gb-whatsapp-pro-inapp-langauge-change.00d87a39.webp";